/**
 * SheetSelector - Component for selecting Excel sheets
 * author: Generated Component
 */
import React from 'react';
import { Row, Col, Card, Badge } from 'react-bootstrap';


const SheetSelector = ({ sheets, selectedSheet, onSheetSelect, t }) => {
  if (!sheets || sheets.length === 0) {
    return (
      <div data-testid="sheet-selector">
        <div className="text-center p-5 border border-2 border-dashed bg-light">
          <p className="text-muted">{t("SheetSelector.noSheets.label")}</p>
        </div>
      </div>
    );
  }

  const handleSheetClick = (sheet) => {
    onSheetSelect(sheet);
  };

  return (
    <div data-testid="sheet-selector">
      <div className="text-center mb-4">
        <h6>{t("SheetSelector.title.label")}</h6>
        <p className="text-muted">{t("SheetSelector.subtitle.label")}</p>
      </div>

      <Row>
        {sheets.map((sheet, index) => (
          <Col key={sheet.name} lg={4} md={6} sm={12} className="mb-3">
            <Card 
              className={`${selectedSheet?.name === sheet.name ? 'border-success bg-success bg-opacity-10' : ''}`}
              style={{ cursor: 'pointer' }}
              onClick={() => handleSheetClick(sheet)}
              data-testid={`sheet-card-${index}`}
            >
              <Card.Body>
                <div className="d-flex align-items-start gap-3 mb-3">
                  <div className="bg-light rounded p-2" style={{ width: '48px', height: '48px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <i className="fas fa-table text-muted"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h6 className="mb-2">{sheet.name}</h6>
                    <div className="d-flex gap-2 flex-wrap">
                      <Badge bg="secondary" className="small">
                        {sheet.rowCount} {t("SheetSelector.stats.rows.label")}
                      </Badge>
                      <Badge bg="info" className="small">
                        {sheet.columnCount} {t("SheetSelector.stats.columns.label")}
                      </Badge>
                    </div>
                  </div>
                </div>

                {sheet.columns && sheet.columns.length > 0 && (
                  <div className="border-top pt-3">
                    <p className="small fw-600 mb-2">{t("SheetSelector.preview.title.label")}:</p>
                    <div className="d-flex flex-wrap gap-1">
                      {sheet.columns.slice(0, 5).map((column, colIndex) => (
                        <span key={colIndex} className="badge bg-light text-dark small">
                          {column.name}
                        </span>
                      ))}
                      {sheet.columns.length > 5 && (
                        <span className="text-muted small">
                          +{sheet.columns.length - 5} {t("SheetSelector.preview.more.label")}
                        </span>
                      )}
                    </div>
                  </div>
                )}

                {selectedSheet?.name === sheet.name && (
                  <div className="bg-success text-white rounded p-2 mt-3 d-flex align-items-center gap-2">
                    <i className="fas fa-check-circle"></i>
                    <span className="small">{t("SheetSelector.selected.label")}</span>
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {selectedSheet && (
        <div className="mt-4">
          <Card>
            <Card.Header className="bg-success text-white">
              <h6 className="mb-0">{t("SheetSelector.selectedInfo.title.label")}</h6>
            </Card.Header>
            <Card.Body>
              <Row>
                <Col md={6}>
                  <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                    <strong>{t("SheetSelector.selectedInfo.sheetName.label")}:</strong>
                    <span className="text-muted">{selectedSheet.name}</span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                    <strong>{t("SheetSelector.selectedInfo.totalRows.label")}:</strong>
                    <span className="text-muted">{selectedSheet.rowCount}</span>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                    <strong>{t("SheetSelector.selectedInfo.totalColumns.label")}:</strong>
                    <span className="text-muted">{selectedSheet.columnCount}</span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center py-2">
                    <strong>{t("SheetSelector.selectedInfo.dataPreview.label")}:</strong>
                    <span className="text-muted">{t("SheetSelector.selectedInfo.available.label")}</span>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </div>
      )}
    </div>
  );
};

export default SheetSelector; 